import React from 'react'
// @ts-ignore no types
import { Icon } from '@adc/ui-morpheus'
// @ts-ignore no types
import { BaseCell } from '@adc/datatable'

const BASE_ELM_ID = 'row'

interface EditCellProps {
  value: string | number
  rowIndex: number
  classes?: string[]
  onClick: (value: string | number, rowIndex: number) => void
  [key: string]: unknown // To allow any additional props
}

const EditCell: React.FC<EditCellProps> = ({
  value,
  rowIndex,
  onClick,
  ...rest
}) => {
  return (
    <BaseCell {...rest}>
      <div
        style={{ cursor: 'pointer' }}
        data-elm-id={`${BASE_ELM_ID}_${rowIndex}_open_button`}
        onClick={() => onClick(value, rowIndex)}
        role='secondary'
      >
        <Icon name='eye' color='info' size='large' fitted />
      </div>
    </BaseCell>
  )
}

export default EditCell
